<template>
  <i class="c-icon-required" :style="{ color: colorCode }">*</i>
</template>

<script lang="ts">
import commons from "@/common/store/modules/commons";
import { Vue } from 'vue-class-component';
import { Options } from 'vue-class-component';

@Options({})
export default class IconRequired extends Vue {
  get colorCode() {
    return commons?.colorCode;
  }
}
</script>

<style scoped>
.c-icon-required {
  color: rgb(238, 28, 37);
  margin-left: 5px;
}
</style>
